import { useHydraMutation, HydraMutationParams } from './useHydraMutation';

export function useActivateEpqRequestUserAccessMutation(params?: HydraMutationParams) {
  return useHydraMutation('api/epq_request_user_access_activations', {
    ...params,
  });
}
